import {defineMessages} from 'react-intl'

export default defineMessages({
    queryPlaceholderPrivate: {
        id: 'containers.Explore.filters.queryPlaceholderPrivate',
        defaultMessage: 'ID, name, e-mail or ethnicity',
    },
    queryPlaceholderPublic: {
        id: 'containers.Explore.filters.queryPlaceholderPublic',
        defaultMessage: 'Search voice ID',
    },
    'collections.voicestar': {
        id: 'containers.Explore.filters.collections.voicestar',
        defaultMessage: 'Voice Stars',
    },
    'languagesProficiency.native': {
        id: 'containers.Explore.filters.languagesProficiency.native',
        defaultMessage: 'Native and bilingual proficiency',
    },
    'languagesProficiency.full-professional': {
        id: 'containers.Explore.filters.languagesProficiency.full-professional',
        defaultMessage: 'Full professional proficiency',
    },
    'languagesProficiency.professional': {
        id: 'containers.Explore.filters.languagesProficiency.professional',
        defaultMessage: 'Professional working proficiency',
    },
    'languagesProficiency.limited': {
        id: 'containers.Explore.filters.languagesProficiency.limited',
        defaultMessage: 'Limited working proficiency',
    },
    'languagesProficiency.elementary': {
        id: 'containers.Explore.filters.languagesProficiency.elementary',
        defaultMessage: 'Elementary proficiency',
    },
    title: {
        id: 'containers.Explore.title',
        defaultMessage: '{language} Voice Actors and Talent',
    },
    body: {
        id: 'containers.Explore.body',
        defaultMessage:
            'In need of a {language} voice-over artist? Our voice-over services are backed up by 20 years of experience. With a variety of dialects, we have a vast roster of the best {language} voice-over actors handpicked to supply high-quality voice-overs for your project. To ensure the best quality, all our {language} voice talents are native speakers. We want to help you find the right voice to convey your message and contribute to your success. To that end, we activate our global organization that consistently delivers high-quality expertise, is aware of your deadlines and exceeds your expectations from start to finish.\n\nReach out by calling us at <telephoneLink>+45 89 87 30 03</telephoneLink> or simply <emailLink>write us an e-mail</emailLink>.',
    },
    metaTitle: {
        id: 'containers.Explore.meta.title',
        defaultMessage:
            '{language} Voice Over • Find {language} Voice Actors and Talents | VoiceArchive',
    },
    metaDescription: {
        id: 'containers.Explore.meta.description',
        defaultMessage:
            'Listen to {language} voice actors and talents. Find the perfect voice for your project. Free custom demo. Quick and easy.',
    },
    voiceStarsOnly: {
        id: 'containers.Explore.filters.voicestarOnly',
        defaultMessage: 'Only show <highlight>recommended</highlight>',
    },
    aiSuggestBanner: {
        id: 'containers.ExplorePage.aiSuggestBanner',
        defaultMessage: "<p><b>Try our new AI tool!</b> Simply paste a bit of your manuscript, and get instant voice talent recommendations {left_arrow}</p>"

    },
    ToneOfVoice: {
        id: 'containers.ExplorePage.ToneOfVoice',
        defaultMessage: 'Tone of Voice'
    },
    demoLanguages: {
        id: 'containers.ExplorePage.demoLanguages',
        defaultMessage: 'Demo languages'
    },
    age: {id: 'containers.ExplorePage.age', defaultMessage: 'All Ages'},
    ageGroupChildren: {id: 'containers.ExplorePage.ageGroupChildren', defaultMessage: 'Children'},
    ageGroupYoung: {id: 'containers.ExplorePage.ageGroupYoung', defaultMessage: 'Young'},
    ageGroupAdult: {id: 'containers.ExplorePage.ageGroupAdult', defaultMessage: 'Adult'},
    ageGroupOld: {id: 'containers.ExplorePage.ageGroupOld', defaultMessage: 'Old'},
    ageGroupNoChildren: {id: 'containers.ExplorePage.ageGroupNoChildren', defaultMessage: 'No Children'},
    availability: {id: 'containers.ExplorePage.availability', defaultMessage: 'Availability'},

    new: {id: 'containers.ExplorePage.new', defaultMessage: 'New'},
    newAnyTime: {id: 'containers.ExplorePage.newAnyTime', defaultMessage: 'Any time'},
    newLastMonths: {id: 'containers.ExplorePage.newLastMonths', defaultMessage: 'Last {months, plural, one {month} other {# months}}'},
    newCustomDate: {id: 'containers.ExplorePage.newCustomDate', defaultMessage: 'Since date'},
    newOnly: {id: 'containers.ExplorePage.newOnly', defaultMessage: 'New voices only'},

    voicesOrdered:{id:'containers.ExplorePage.VoicesOrdered', defaultMessage:'voices ordered by'},

    sortDirectionBestMatches:{id:'containers.ExplorePage.sortDirectionBestMatches', defaultMessage:'Best matches'},
    sortDirectionRecommended:{id:'containers.ExplorePage.sortDirectionRecommended', defaultMessage:'Recommended'},
    sortDirectionNewestVoices:{id:'containers.ExplorePage.sortDirectionNewestVoices', defaultMessage:'Newest voices'},
    sortDirectionMostExperienced:{id:'containers.ExplorePage.sortDirectionMostExperienced', defaultMessage:'Most experienced'},
    sortDirectionVoiceIDAscending:{id:'containers.ExplorePage.sortDirectionVoiceIDAscending', defaultMessage:'Voice ID (A-Z)'},
    sortDirectionVoiceIDDescending:{id:'containers.ExplorePage.sortDirectionVoiceIDDescending', defaultMessage:'Voice ID (Z-A)'},
    sortDirectionCostAscending:{id:'containers.ExplorePage.sortDirectionCostAscending', defaultMessage:'Cost (&uarr;)'},
    sortDirectionCostDescending:{id:'containers.ExplorePage.sortDirectionCostDescending', defaultMessage:'Cost (&darr;)'},
    restFiler:{id:'containers.ExplorePage.restFiler', defaultMessage:'Reset filters'},
    loggedInMessage:{id:'containers.ExplorePage.loggedInMessage', defaultMessage:'Logged in as {name}'},
    logOutButton:{id:'containers.ExplorePage.logOutButton', defaultMessage:'Log out'},
    includeSelectedVoiceOnly:{id:'containers.ExplorePage.includeSelectedVoiceOnly', defaultMessage:'Include selected voices only'},
    includeFilterResultsCoordinator:{id:'containers.ExplorePage.includeFilterResultsCoordinator', defaultMessage:'Include all results from current filters, with future auto update'},
    includeFilterResultsPublic:{id:'containers.ExplorePage.includeFilterResultsPublic', defaultMessage:'Share your current search with a colleague'},
    includeAll:{id:'containers.ExplorePage.includeAll', defaultMessage:'All'},
    buttonAutoSuggestWithAi:{id:'containers.ExplorePage.buttonAutoSuggestWithAi', defaultMessage:'Auto-suggest with AI'},
    saveProgress:{id:'containers.ExplorePage.saveProgress', defaultMessage:'You have previously saved {amount} voices. Do you want to pick up where you left?'},
    restoreProject:{id:'containers.ExplorePage.button.restoreProject', defaultMessage:'Yes, let me continue'},
    loadMore:{id:'containers.ExplorePage.button.loadMore', defaultMessage:'Load more'},
    loadMoreDisable:{id:'containers.ExplorePage.button.loadMoreDisable', defaultMessage:'No more matches for your search'},
    addCharacter:{id:'containers.ExplorePage.button.addCharacter', defaultMessage:'Add character'},
    characterName:{id:'containers.ExplorePage.button.characterName', defaultMessage:'Character name:'},
})
